<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ date.label }}</mat-label>

  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="control"
    [placeholder]="date.label"
    [min]="date.isFutureDateSelected ? today : null"
    [max]="date.isPastDateSelected ? today : null"
    (click)="picker.open()"
    required="{{ date.isRequired }}"
  />

  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>

  <mat-error *ngIf="control.hasError('required')">
    {{ date.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  <!-- Past time not allowed -->
  <mat-error *ngIf="control.hasError('pastDateNotAllowed')">
    {{ 'common.error.past-time-not-allowed' | translate }}
  </mat-error>

  <!-- Future time not allowed -->
  <mat-error *ngIf="control.hasError('futureDateNotAllowed')">
    {{ 'common.error.future-time-not-allowed' | translate }}
  </mat-error>
</mat-form-field>
